<template>
  <div
    :class="['step-banner-wrapper']"
    v-resizeObserver="{
      openResize: true,
      handler: observerCallBack
    }"
  >
    <div class="pc-container" v-if="!(currentWidth < calMobileWidth)">
      <div class="pc-container-item" v-for="(item, index) in calData" :key="index">
        <slot :item="Object.assign(item, { index: index + 1 })"></slot>
      </div>
      <div class="banner-faq">
        <a href="http://www.vftradings.com/faq" target="_blank">{{ $t('propTrade.banner.faq') }}</a>
        <span>></span>
      </div>
    </div>
    <div class="mobile-container" v-else>
      <el-carousel :interval="5500" trigger="click" arrow="never">
        <el-carousel-item v-for="(item, index) in calData" :key="index">
          <slot :item="Object.assign(item, { index: index + 1 })"></slot>
        </el-carousel-item>
        <div class="banner-faq moblie">
          <a href="http://www.vftradings.com/faq" target="_blank">{{ $t('propTrade.banner.faq') }}</a>
          <span>></span>
        </div>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepBanner',
  props: {
    data: {
      type: Array,
      default: []
    },
    mobileWidth: {
      type: String | Number,
      default: 768
    }
  },
  data() {
    return {
      currentWidth: 0
    };
  },
  computed: {
    calData() {
      return this.data;
    },
    calMobileWidth() {
      return Number(this.mobileWidth);
    }
  },
  methods: {
    observerCallBack(width) {
      this.currentWidth = width;
      this.$emit('changeStepBannerWidth', this.currentWidth, this.currentWidth < this.calMobileWidth);
    }
  }
};
</script>

<style lang="scss" scoped>
.step-banner-wrapper {
  .banner-faq {
    color: #00f0ff;
    font-size: 14px;
    line-height: 21px;
    position: absolute;
    bottom: -20px;
    z-index: 999;
    @include rtl-sass-prop(right, left, 0);
    a {
      color: #00f0ff;
      text-decoration: none;
      &:hover {
        text-decoration: none !important;
      }
    }
    span {
      cursor: pointer;
      @include rtl-sass-prop(margin-left, margin-right, 4px);
    }
    &.moblie {
      bottom: 40px;
    }
  }
  .pc-container {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    position: relative;
    &-item {
      flex: 1;
      min-width: 220px;
    }
  }
}

/* 自定义指示器样式 */
/deep/.el-carousel__button {
  width: 20px !important;
  border-radius: 20px;
  height: 4px !important;
  opacity: 1;
}

/deep/.el-carousel__indicator.is-active {
  .el-carousel__button {
    background-color: $primary-blue; /* 激活状态的颜色 */
  }
}

/deep/.el-carousel__arrow--left {
  left: 4px;
}
/deep/.el-carousel__arrow--right {
  right: 4px;
}

[dir='rtl'] * /deep/.el-icon-arrow-left {
  transform: rotate(360deg);
}
[dir='rtl'] * /deep/.el-icon-arrow-right {
  transform: rotate(360deg);
}
</style>
